// extracted by mini-css-extract-plugin
export default {"container":"InfoAboutPalmsStep_container__jEg+E","imageContainer":"InfoAboutPalmsStep_imageContainer__typVl","btnContainer":"InfoAboutPalmsStep_btnContainer__DgVF1"};